import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

export const VENDOR_PURCHASE_ORDERS_TARGET_KIND = "vendorPurchaseOrders";
export const PURCHASE_ORDERS_BASE_PATH = "/produce/purchasing/orders";
const VENDOR_PURCHASE_ORDERS_ROUTE_PATTERN = /^\/produce\/purchasing\/orders\/vendor\/([^/?#]+)$/;

export const matchVendorPurchaseOrdersRoute = (pathname: string): ContinuationTarget | null => {
	const match = VENDOR_PURCHASE_ORDERS_ROUTE_PATTERN.exec(pathname);
	if (!match) return null;
	try {
		return { targetId: decodeURIComponent(match[1]), targetKind: VENDOR_PURCHASE_ORDERS_TARGET_KIND };
	} catch {
		return null;
	}
};

const vendorPurchaseOrdersReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId }) => `${PURCHASE_ORDERS_BASE_PATH}/vendor/${encodeURIComponent(targetId)}`,
	matchesRoute: matchVendorPurchaseOrdersRoute
};

export default vendorPurchaseOrdersReceiverIdentityAdapter;
